import { IssueDecisionTimeReportResult } from '@tap/data-providers';
import { XGridTableWrap } from '@tap/mui-ui';
import { dateTimeHelper } from '@tap/utils';

/* Таблица Время на решение заявок
*/


type IssueDecisionTimeTableProps = {
    reportData: IssueDecisionTimeReportResult[],
}

export default function IssueDecisionTimeTable({ reportData }: IssueDecisionTimeTableProps) {

    return (
        <XGridTableWrap
            rows={reportData.map(row => ({ ...row, id: row.endDate }))}
            dataIsLoading={false}
            tableHeight={'calc(100vh - 160px)'}
            tableWidth={'90%'}
            columns={[
                {
                    field: 'endDate',
                    headerName: 'Дата',
                    sortable: false,
                    type: 'date',
                    flex: 1,
                    renderCell: cellParams => dateTimeHelper.formatDate(new Date(cellParams.row.endDate), 'dd MMMM yyyy'),
                    valueGetter: value => new Date(value),
                },
                {
                    field: 'completedIssueCount',
                    headerName: 'Завершено заявок',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                },
                {
                    field: 'timeQuantitySum',
                    headerName: 'Суммарное время на решение заявок, ч.',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                    valueGetter: (_val, row) => row.timeQuantitySum,
                },
                {
                    field: 'timeQuantityAvg',
                    headerName: 'Среднее время на решение по заявке, ч.',
                    sortable: false,
                    type: 'number',
                    flex: 1,
                    valueGetter: (_val, row) => row.timeQuantityAvg,
                },
            ]}

        />
    );
}

